import React, { useState } from "react";

interface RandomSumPopupProps {
  isVisible: boolean;
  onClose: () => void;
  onSuccess: () => void; // Function to call after validation success
}

const RandomSumPopup: React.FC<RandomSumPopupProps> = ({
  isVisible,
  onClose,
  onSuccess,
}) => {
  const [num1, setNum1] = useState(0);
  const [num2, setNum2] = useState(0);
  const [userInput, setUserInput] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  React.useEffect(() => {
    if (isVisible) {
      const random1 = Math.floor(Math.random() * 5) + 1; // Random number between 1-5
      const random2 = Math.floor(Math.random() * 5) + 1;
      setNum1(random1);
      setNum2(random2);
      setUserInput("");
      setErrorMessage("");
    }
  }, [isVisible]);

  const validateSum = () => {
    const userSum = parseInt(userInput, 10);
    if (isNaN(userSum)) {
      setErrorMessage("Please enter a valid number.");
      return;
    }
    if (userSum === num1 + num2) {
      onSuccess(); // Call the success callback
      onClose(); // Close the popup
    } else {
      setErrorMessage("Incorrect sum. Please try again.");
    }
  };

  if (!isVisible) return null;

  return (
    <div style={popupStyles}>
      <div style={popupContentStyles}>
        <h2 style={{ color: " #32AAFF", margin: 16 }}>
          <strong>
            {num1} + {num2}
          </strong>
        </h2>
        <input
          type="number"
          value={userInput}
          onChange={(e) => setUserInput(e.target.value)}
          style={inputStyles}
        />
        {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
        <button onClick={validateSum} style={buttonStyles}>
          Submit
        </button>
        <button
          onClick={onClose}
          style={{
            ...buttonStyles,
            backgroundColor: "#E6F9FF",
            color: "black",
          }}
        >
          Close
        </button>
      </div>
    </div>
  );
};

// Styles
const popupStyles: React.CSSProperties = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
};

const popupContentStyles: React.CSSProperties = {
  backgroundColor: "white",
  padding: "20px",
  borderRadius: "8px",
  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  textAlign: "center",
  width: "300px",
};

const inputStyles: React.CSSProperties = {
  margin: "10px 0",
  padding: "8px",
  width: "80%",
  fontSize: "16px",
};

const buttonStyles: React.CSSProperties = {
  margin: "5px",
  padding: "10px 20px",
  backgroundColor: "#3287FF",
  color: "white",
  border: "none",
  borderRadius: "15px",
  cursor: "pointer",
};

export default RandomSumPopup;
